import type { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { StorageService } from '../services/storage.service';

export const tokenInterceptor: HttpInterceptorFn = (request, next) => {

  const storageService = inject(StorageService);

  if (storageService.getToken()) {
    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${storageService.getToken()}`,
      },
    });
  }

  return next(request);
};